#chat-message-bar {
  display: flex;
  width: 100%;
  transition: all 0.3s ease;
  align-items: end;

  &.has-text {
    ux-button {
      opacity: 1;
      width: auto;
      margin-left: 8px;
      pointer-events: all;
    }
  }
}

#chat-textarea {
  flex: 1;
  transition: all 0.3s ease;
  padding: 8px;
  height: var(--ux-button-min-height);
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: inherit;

  &::placeholder {
    vertical-align: middle;
  }
}

ux-button {
  opacity: 0;
  width: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  white-space: nowrap;
  padding: 0;
  margin: 0;
  cursor: pointer;
  pointer-events: none;
  flex-shrink: 0;
}